const LoyaltyIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm-4 5h4'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
  </svg>
);

export default LoyaltyIcon;
